export default __webpack_public_path__ + "static/carole-9ccf5001955d615b7efe06f5980199c4.png";